export default {
  // global theme for the app
  globalTheme: 'light', // light | dark

  // dark theme colors
  dark: {
    textbase: '#edf0f2',
    background: '#05090c',
    surface: '#111b27',
    primary: '#0096c7',
    secondary: '#a5d6a7',
    accent: '#59bbbb',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4169e1',
    warning: '#FFC107'
  },

  // light theme colors
  light: {
    //textbase: '#222222',
    textbase: '#26a69a',
    background: '#ffffff',
    surface: '#f2f5f8',
    primary: '#4169e1',
    secondary: '#5674ce5d',
    accent: '#59bbbb',
    error: '#ef476f',
    info: '#4169e1',
    success: '#4169e1',
    warning: '#ffd166'
  }
}
